import React from 'react';
import styled from 'styled-components';
import PageContainer from '../../components/containers/PageContainer';
import { theme } from '../../assets/styles/theme';
import FeatureFlagsTable from './components/FeatureFlagsTable';

const Container = styled.div`
  padding: 10px ${theme.paddingStandard}px 0 ${theme.paddingStandard}px;
  flex-direction: column;
  display: flex;
  width: 100%;
`;

const FeatureFlags = () => {
  return (
    <PageContainer>
      <Container>
        <FeatureFlagsTable />
      </Container>
    </PageContainer>
  );
};

export default FeatureFlags;
